import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";
import {
  type ApiKey,
  type SetApiKeyRequest,
  type SetApiKeyResponse,
} from "utils/types/api_keys.type";

// Get API Keys
export const useGetApiKeys = () =>
  useQuery<ApiKey[], Error>(
    ["getApiKeys"],
    async () => await client("admin/get-api-keys").then((res) => res.data)
  );

// Set API Key (Super Admin only)
export const useSetApiKey = () => {
  const queryClient = useQueryClient();
  return useMutation<SetApiKeyResponse, Error, SetApiKeyRequest>(
    async (data) =>
      await client("admin/update-api-key", {
        data,
      }).then((res) => res.data),
    {
      onSuccess() {
        void queryClient.invalidateQueries(["getApiKeys"]);
      },
    }
  );
};

